import React, { useEffect, useState } from 'react';
import { DetailList, Field, InlineAlert, PageHeader } from '../../components/ui/Primitives';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';
import { addUserProfileFs } from '../../utils/firestoreStore';
import { courseName } from '../../utils/display';

export default function Profile() {
  const { user, updateProfile } = useAuth();
  const { courses = [] } = useData() || {};
  const [form, setForm] = useState({ firstName: '', lastName: '', phone: '' });
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState({ tone: '', message: '' });
  useEffect(() => setForm({ firstName: user?.firstName || '', lastName: user?.lastName || '', phone: user?.phone || '' }), [user?.firstName, user?.lastName, user?.phone]);
  const course = courses.find(item => item.id === user?.courseId);
  const save = async event => {
    event.preventDefault();
    if (!form.firstName.trim() || !form.lastName.trim()) { setStatus({ tone: 'danger', message: 'Enter both your first and last name.' }); return; }
    setSaving(true); setStatus({ tone: '', message: '' });
    try {
      const updates = { firstName: form.firstName.trim(), lastName: form.lastName.trim(), phone: form.phone.trim() };
      await addUserProfileFs(user.id, updates);
      updateProfile(updates);
      setStatus({ tone: 'success', message: 'Your profile has been updated.' });
    } catch (error) {
      console.error('Failed to update profile', error);
      setStatus({ tone: 'danger', message: 'Your changes could not be saved. Please try again.' });
    } finally { setSaving(false); }
  };

  return (
    <div className="profile-page">
      <PageHeader eyebrow="Account" title="Profile" description="Manage your personal details and review your academic record." />
      {status.message && <InlineAlert tone={status.tone}>{status.message}</InlineAlert>}
      <form onSubmit={save}>
        <section className="profile-section">
          <h2>Personal information</h2>
          <div className="ui-form-grid">
            <Field label="First name"><input value={form.firstName} onChange={event => setForm(previous => ({ ...previous, firstName: event.target.value }))} autoComplete="given-name" /></Field>
            <Field label="Last name"><input value={form.lastName} onChange={event => setForm(previous => ({ ...previous, lastName: event.target.value }))} autoComplete="family-name" /></Field>
            <Field label="Email" hint="Contact support if your sign-in email needs to change."><input value={user?.email || ''} readOnly /></Field>
            <Field label="Phone"><input value={form.phone} onChange={event => setForm(previous => ({ ...previous, phone: event.target.value }))} autoComplete="tel" /></Field>
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save changes'}</button>
        </section>
      </form>
      <section className="profile-section">
        <h2>Academic information</h2>
        <DetailList items={[
          { label: 'Course', value: course ? courseName(course) : user?.intake },
          { label: 'Intake', value: user?.intake },
          { label: 'Learning access', value: user?.lmsActive ? 'Active' : (user?.accessStatus || 'Pending') }
        ]} />
      </section>
    </div>
  );
}
